export default "__VITE_ASSET__BALB12Fi__"